
import EmailIcon from '@mui/icons-material/Email';
import { ListItemAvatar, ListItemText, Stack } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
export const Contact = () => (
    <>
        <Typography variant="h3" gutterBottom marginTop={"32px"}>
            Kontakt
        </Typography>
        <ListItem alignItems="flex-start">
            <ListItemAvatar>
                <EmailIcon />
            </ListItemAvatar>
            <ListItemText
                primary="marcin.lesinski@focus-roleplay.games"
                secondary={
                    "Autor systemu F©US"
                }
            />
        </ListItem>
    </>
)